import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { RouteNavbar } from '@shared/components/navigation/interfaces/routes-navbar';

@Component({
  selector: 'app-sidebar-dropdown',
  imports: [NgIcon, RouterLink, RouterLinkActive],
  templateUrl: './sidebar-dropdown.html',
  styleUrl: './sidebar-dropdown.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarDropdown {
  route = input.required<RouteNavbar>();
  itemClicked = output<void>();

  isOpen = signal<boolean>(false);

  toggle(): void {
    this.isOpen.set(!this.isOpen());
  }

  onChildClick(): void {
    this.itemClicked.emit();
  }
}
